import { useEffect, useRef } from "react"
import "../../../Styles/main.scss"

function AuthPageImage() {
    const videoRef = useRef<HTMLVideoElement>(null)
    const coverRef = useRef<HTMLImageElement>(null)

    const videoPausePlayHandler = (e: Event) => {
        if(videoRef.current === null || coverRef.current === null) return
        if (e.type === "playing") {
            videoRef.current.setAttribute("controls", "controls")
        } else if (e.type === "ended") {
            videoRef.current.classList.add("hidden")
            coverRef.current.classList.remove("hidden")
        }
    }

    const coverClickHandler = (e: Event) => {
        if(videoRef.current === null || coverRef.current === null) return
        videoRef.current.classList.remove('hidden')
        videoRef.current.currentTime = 0
        videoRef.current.play()

        coverRef.current.classList.add('hidden')
    }

    useEffect(() => {
        if(videoRef.current === null || coverRef.current === null) return
        videoRef.current.addEventListener("playing", videoPausePlayHandler, false)
        videoRef.current.addEventListener("pause", videoPausePlayHandler, false)
        videoRef.current.addEventListener("ended", videoPausePlayHandler, false)

        coverRef.current.addEventListener("click",coverClickHandler,false)
    })

    return (
        <>
        <img ref={coverRef} className="edusiia-cover" src="/edusiia-Community-Video-Splash.gif" />
        <div className="video-wrapper ">
            <video
                className="edusiia-video hidden"
                poster="/edusiia-Community-Video-Splash.gif"
                preload="auto"
                playsInline
                ref={videoRef}
            >
                <source src="edusiia-das-soziale-netzwerk.mp4" type="video/mp4" />
            </video>
            
        </div>
        </>
    )
}

export default AuthPageImage
